module.exports = __webpack_public_path__ + "img/home_dropping.7c955dd1.webp";